import React from 'react'
import LKGrid from '../../LKGrid'
import LKModal, { LKModalContainer, LKModalTrigger } from '../../LKModal'

import translate from './translate'
import { ClientValidationResultsProps } from './ClientValidationResults.types'
import { GridApi } from 'ag-grid'

const colors = {
  90: '#21ba45',
  100: '#21ba45',
  150: '#ffc107',
  200: '#db2828',
}

const LKGridConfig = {
  gridIdentity: {
    formName: 'frm_client_validation_results',
    objectName: 'dbgrd_errors',
  },

  syncGridState: false,
  selectLastRow: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  getRowStyle: ({
    node: {
      data: { ErrorLevelID },
    },
  }) => {
    return { color: colors[ErrorLevelID] }
  },

  columnDefs: [
    { headerName: 'ErrorMessage', field: 'ErrorMessage', width: 400 },
    { headerName: 'ErrorLevel', field: 'ErrorLevel', width: 350 },
  ],

  columnConfigs: {
    OSBalance: {
      cellStyle: { textAlign: 'right' },
    },

    Black: {
      iconComponent: (value: number) => (value === 1 ? 'skull' : null),
    },

    OVDDays: {
      cellStyle: { textAlign: 'right' },
    },

    TotalOVDDays: {
      cellStyle: { textAlign: 'right' },
    },
  },
}

//@ts-ignore
@LKModalContainer('ClientValidationResults')
class ClientValidationResults extends React.Component<ClientValidationResultsProps> {
  onGridReady = ({ api }: { api: GridApi }) => {
    api.setHeaderHeight(0)
  }

  handleClose = () => {
    if (this.props.onClose) {
      this.props.onClose({ params: this.props.params })
    }
  }

  render() {
    const { modalInstanceName, loading, params } = this.props
    return (
      //@ts-ignore
      <LKModal
        name={modalInstanceName}
        icon="alert"
        heading={translate('frm_client_validation_results')}
        onClose={this.handleClose}
        loading={loading}
        size="sm-3"
        //@ts-ignore
        footer={<LKModal.Footer sideActions={<LKModal.CancelButton text={translate('cmd_cancel')} />} />}
      >
        <p
          style={{
            backgroundColor: colors[params.ErrorLevel],
            padding: '15px 10px',
            marginBottom: 10,
            color: 'white',
            fontWeight: 'bold',
            textAlign: 'center',
          }}
        >
          {translate('pan_warning')}
        </p>

        <div style={{ flex: 1, position: 'relative' }}>
          <LKGrid
            onGridReady={this.onGridReady}
            instanceName="ClientValidationResults"
            rowData={params.Data}
            {...LKGridConfig}
          />
        </div>
      </LKModal>
    )
  }
}

export const ClientValidationResultsTrigger = ({
  children,
  params,
}: {
  children: React.ReactNode
  params: { [key: string]: any }
}) => (
  //@ts-ignore
  <LKModalTrigger params={params} alias="cmd_verify" name="ClientValidationResults">
    {children}
  </LKModalTrigger>
)

export default ClientValidationResults
